import Swiper, { Autoplay, Thumbs, Navigation } from 'swiper';

document.addEventListener( 'alpine:init', () => {
	Alpine.data( 'swiper_carousel', ( options = {} ) => ( {
		init() {
			let self = this;
			let thumbs = null;
			let gallery = null;
			let direction = window.innerWidth <= 1279 ? 'horizontal' : 'vertical';

			if ( this.$refs.thumbs ) {
				thumbs = new Swiper( this.$refs.thumbs, {
					modules: [ Autoplay, Thumbs ],
					init: false,
					loop: false,
					spaceBetween: 8,
					slidesPerView: 4,
					watchSlidesProgress: true,
					direction: direction,
					breakpoints: {
						1280: {
							slidesPerView: 'auto',
							spaceBetween: 16,
						},
					},
				} );

				thumbs.init();
			}

			/**
			 * @type {object}
			 **/
			gallery = new Swiper( this.$refs.container, {
				modules: [ Autoplay, Thumbs, Navigation ],
				navigation: {
					nextEl: this.$refs.next,
					prevEl: this.$refs.prev,
				},
				thumbs: {
					swiper: thumbs ? thumbs : null,
				},
				...options,
			} );

			gallery.init();
		},
		slidePrev: () => {
			gallery.slidePrev();
		},
		slideNext: () => {
			gallery.slideNext();
		},
	} ) );
} );
